// Define constants

// Longest challenge a coach can create, in days
export const MAX_CHALLENGE_DAYS = 30;

export const expertiseList = [
  { label: "Awe", value: "Awe" },
  { label: "Compassion", value: "Compassion" },
  { label: "Self-compassion", value: "Self-compassion" },
  { label: "Forgiveness", value: "Forgiveness" },
  { label: "Gratitude", value: "Gratitude" },
  { label: "Happiness", value: "Happiness" },
  { label: "Mindfulness", value: "Mindfulness" },
  { label: "Find Purpose", value: "Find Purpose" },
  { label: "Resilience", value: "Resilience" },
  { label: "Goal-setting", value: "Goal-setting" },
  { label: "Parenting", value: "Parenting" },
  { label: "Worklife", value: "Worklife" },
  { label: "Career", value: "Career" },
  { label: "Relationship", value: "Relationship" },
  { label: "MindBody", value: "MindBody" },
  { label: "Passions", value: "Passions" },
  { label: "Wealth", value: "Wealth" },
  { label: "Spirituality", value: "Spirituality" },
  { label: "Sleep Better", value: "Sleep Better" },
  { label: "Motivation", value: "Motivation" },
  { label: "Self-disipline", value: "Self-disipline" },
  { label: "Communication", value: "Communication" },
];
